import {
  DEFAULT_STAGES,
  GROUP_MATCHES_PER_ROUND,
  KNOCKOUT_STAGE_TITLES,
} from '../AdminPanel/WorldCupAdmin/worldCupAdmin.constants'

export function sortWorldCupMatchesByKickoff(matches) {
  return [...matches].sort(
    (a, b) => new Date(a.kickoffTime).getTime() - new Date(b.kickoffTime).getTime()
  )
}

export function buildWorldCupMatchListSections(matches, stages = DEFAULT_STAGES) {
  const sortedStages = [...stages].sort((a, b) => a.sortOrder - b.sortOrder)
  const groupMatches = sortWorldCupMatchesByKickoff(
    matches.filter((m) => m.stage?.startsWith('Group '))
  )
  const sections = []

  for (let round = 1; round <= 3; round += 1) {
    const start = (round - 1) * GROUP_MATCHES_PER_ROUND
    const roundMatches = groupMatches.slice(start, start + GROUP_MATCHES_PER_ROUND)
    if (roundMatches.length > 0) {
      sections.push({ key: `group-round-${round}`, title: `${round}. runde`, matches: roundMatches })
    }
  }

  const extraGroupMatches = groupMatches.slice(3 * GROUP_MATCHES_PER_ROUND)
  if (extraGroupMatches.length > 0) {
    sections.push({ key: 'group-extra', title: 'Øvrige gruppekampe', matches: extraGroupMatches })
  }

  const knockoutStages = sortedStages.filter((stage) => !stage.name.startsWith('Group '))
  const groupedKnockoutKeys = new Set()

  for (const stage of knockoutStages) {
    const stageMatches = sortWorldCupMatchesByKickoff(
      matches.filter((m) => m.stage === stage.name)
    )
    if (stageMatches.length > 0) {
      groupedKnockoutKeys.add(stage.name)
      sections.push({
        key: `knockout-${stage.name}`,
        title: KNOCKOUT_STAGE_TITLES[stage.name] || stage.name,
        matches: stageMatches,
      })
    }
  }

  const ungroupedKnockout = sortWorldCupMatchesByKickoff(
    matches.filter(
      (m) => !m.stage?.startsWith('Group ') && !groupedKnockoutKeys.has(m.stage)
    )
  )
  if (ungroupedKnockout.length > 0) {
    sections.push({ key: 'knockout-other', title: 'Øvrigt slutspil', matches: ungroupedKnockout })
  }

  return sections
}

export function groupWorldCupMatchesByDate(matches, fmtDateHeading) {
  const groups = new Map()

  matches.forEach((match) => {
    const d = new Date(match.kickoffTime)
    const dateKey = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
    if (!groups.has(dateKey)) {
      groups.set(dateKey, {
        dateKey,
        label: fmtDateHeading(match.kickoffTime),
        sortTime: new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(),
        matches: [],
      })
    }
    groups.get(dateKey).matches.push(match)
  })

  return [...groups.values()]
    .sort((a, b) => a.sortTime - b.sortTime)
    .map((group) => ({
      ...group,
      matches: [...group.matches].sort(
        (a, b) => new Date(a.kickoffTime).getTime() - new Date(b.kickoffTime).getTime()
      ),
    }))
}
